module.exports = __webpack_public_path__ + "img/CM_MARSHMALLOW.65c6c6f6.png";